import React, { useRef, useState } from "react";
import { FiSearch } from "react-icons/fi";
import styles from "./srchBox.module.css";

interface SrchBoxProps {
  onUpd?: (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => void;
  placeholder?: string;
}

const SrchBox: React.FC<SrchBoxProps> = ({ onUpd, placeholder }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState<string>("");

  const handleIconClick = () => {
    inputRef.current?.focus();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.currentTarget.value;
    setValue(v);
    onUpd && onUpd(e as any, v);
  };

  const isActive = value.trim().length > 1;

  return (
    <div className={styles.searchContainer} aria-label="Search">
      <input
        ref={inputRef}
        className={styles.searchInput}
        placeholder={placeholder || "Search..."}
        onChange={handleChange}
        value={value}
        aria-label="Search input"
      />

      <button
        type="button"
        className={`${styles.iconButton} ${isActive ? styles.iconActive : ""}`}
        onClick={handleIconClick}
        aria-label="Open search"
      >
        <FiSearch className={styles.searchIcon} />
      </button>
    </div>
  );
};

export default SrchBox;
